module.exports = __webpack_public_path__ + "img/goDown.49150d10.svg";